/**
 * Constants for intake list filtering
 */

// Filter status values used in the intake list page
export const INTAKE_LIST_STATUS = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  COMPLETED: "COMPLETED",
};

// Default status for intake list filters
export const DEFAULT_INTAKE_LIST_STATUS = INTAKE_LIST_STATUS.ACTIVE;

// Valid status values as an array (for validation)
export const VALID_INTAKE_LIST_STATUSES = Object.values(INTAKE_LIST_STATUS);

// Sort options for intake list
export const INTAKE_LIST_SORT = {
  NEWEST: "newest",
  OLDEST: "oldest",
};

// Valid sort values as an array (for validation)
export const VALID_INTAKE_LIST_SORTS = Object.values(INTAKE_LIST_SORT);
